import React, { useContext, useEffect, useState } from 'react'
import { AfterLoginLayoutWrapper } from '../_styles/EPL_AfterLoginLayoutWrapper_think'
import Button from '../../components/core/EPL_Button_Think'
import FloatingInput from '../../components/base/FloatingInput'
import { isValidUDYAMNumber } from '../../shared/validations/UDYAMNumber'
import useMediaQuery from '../../hooks/useMediaQuery'
import { GetCustomerDetailsContext, validateInputExistenece } from '../../App'
import { encrypt } from "../../utils/crypto";
import { UDYAM_SEND_OTP, UDYAM_VERIFY } from '../../Config'
import sendRequest from '../../utils/sendRequest'
import { getRouteFromLoanStageService } from '../../shared/services/getRouteFromLoanStageService'
import { useNavigate } from 'react-router-dom'
import { UdyamWrapper } from './_styles/UdyamWrapper'
import Title from '../../components/core/Title'
import { isValidOTP } from "../../shared/validations/OTP.js";
import OTPInput from "../../components/base/OtpInput.js";
import Modal from '../../components/advance/Modal.js'
import ShimmerPage from '../other-pages/ShimmerPage.js'
import ScenarioBasedModal from '../other-pages/Modals/ScenarioBasedModal.js'
import { isValidMobileNumber } from '../../shared/validations/MobileNumber.js'
import { encryptedData } from '../../utils/index.js'

const Udyam = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("screen and (max-width: 768px)");
    const [customerDetails, setCustomerDetails] = useContext(
        GetCustomerDetailsContext
    );
    const [showShimmer, setShowShimmer] = useState(false);
    const [UDYAM, setUDYAM] = useState("");
    const [UDYAMError, setUDYAMError] = useState(false);
    const [UDYAMErrorMessage, setUDYAMErrorMessage] = useState(
        "Please enter Valid UDYAM"
    );
    const [mobileNumber, setMobileNumber] = useState("");
    const [mobileNumberError, setMobileNumberError] = useState(false);
    const [mobileNumberErrorMessage, setMobileNumberErrorMessage] = useState(
        "Please enter valid mobile number"
    );
    const [otp, setOtp] = useState("");
    const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [udyamVerifyError, setUdyamVerifyError] = useState(false);
    const [udyamVerifyErrorMessage, setUdyamVerifyErrorMessage] = useState("");
    const [isOtpValid, setIsOtpValid] = useState(false);
    const [udyamSkipModal, setUdyamSkipModal] = useState(false);

    useEffect(() => {
        if (
            validateInputExistenece(customerDetails) &&
            validateInputExistenece(customerDetails["stage"])
        ) {
            var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: customerDetails.stage,
            });
            navigate(`${route}`, {
                replace: true,
                state: {
                    customerDetails: customerDetails,
                },
            });
        }
    }, [customerDetails]);

    const resetOTP = async () => {
        const newOtpDigits = [...otpDigits];
        for (let i = 0; i < 6; i++) {
            newOtpDigits[i] = "";
        }
        setOtpDigits(newOtpDigits);
    };

    useEffect(() => {
        var otpString = otpDigits.join("");
        if (isValidOTP(otpString)) {
            setIsOtpValid(true);
            setOtp(otpString);
        } else {
            setIsOtpValid(false);
        }
    }, [otpDigits]);

    const updateUDYAM = (e) => {
        let input = e.target.value.toUpperCase(); // Convert input to uppercase

        // Allow input only if it's within the Udyam number format length
        if (input.length <= 19) {  // UDYAM-XX-YY-1234567 format has 19 characters
            e.target.value = input; // Update the input value to uppercase in real-time
            setUDYAM(input);

            // Validate using the isValidUDYAMNumber utility function
            if (isValidUDYAMNumber(input)) {
                setUDYAMError(false);
            } else {
                setUDYAMError(true);
                setUDYAMErrorMessage("Please enter a valid Udyam Registration Number (UDYAM-XX-00-1234567)");
            }
        } else {
            // If input exceeds the valid length, reset to previous valid input
            e.target.value = UDYAM;
        }
    };

    const allFieldsValidated = () => {
        return (
            isValidUDYAMNumber(UDYAM) &&
            mobileNumber &&
            !mobileNumberError
        );
    };

    const udyamSendOtp = async (skip = false) => {
        try {
            setShowShimmer(true);
            const formData = new FormData();
            // If skip is true, set UDYAM number to "skip"
            const requestData = {
                udyam_number: skip ? "skip" : UDYAM,
            };
            if (!skip) {
                requestData.mobile_number = mobileNumber; // Include mobile number only if UDYAM is not skipped
            }
            formData.append("data", encryptedData(requestData));
            const response = await sendRequest(
                "/" + customerDetails.source + UDYAM_SEND_OTP,
                formData
            );
            setShowShimmer(false);
            if (response.response.Success) {
                setShowOtpModal(true)
            } else {
                setCustomerDetails({
                    ...customerDetails,
                    stage: response.response.STAGE,
                });
            }
        } catch (error) {
            setShowShimmer(false);
            if (error === "Unauthorised") {
                var route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "",
                });
                navigate(`${route}`, {
                    replace: true,
                });
            } else {
                var route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "error",
                });
                navigate(`${route}`, {
                    replace: true,
                });
            }
        }
    };

    const udyamOtpVerify = async () => {
        try {
            setShowShimmer(true);
            const formData = new FormData();
            const requestData = {
                otp: otp,
            };
            formData.append("data", encryptedData(requestData));
            const response = await sendRequest(
                "/" + customerDetails.source + UDYAM_VERIFY,
                formData
            );
            setShowShimmer(false);
            if (response.response.Success) {
                setCustomerDetails({
                    ...customerDetails,
                    stage: response.response.STAGE,
                });
            } else {
                setCustomerDetails({
                    ...customerDetails,
                    stage: response.response.STAGE,
                });
            }
        } catch (error) {
            setShowShimmer(false);
            if (error === "Unauthorised") {
                var route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "",
                });
                navigate(`${route}`, {
                    replace: true,
                });
            } else {
                var route = getRouteFromLoanStageService({
                    source: customerDetails.source,
                    stage: "error",
                });
                navigate(`${route}`, {
                    replace: true,
                });
            }
        }
    };

    const updateMobileNumber = async (e) => {
        if (e.target.value.length <= 10) {
            setMobileNumber(e.target.value);
            if (isValidMobileNumber(e.target.value)) {
                setMobileNumberError(false);
                setMobileNumberErrorMessage("");
            } else {
                setMobileNumberError(true);
                setMobileNumberErrorMessage("Please enter valid mobile number");
            }
        }
    };

    return (
        <>
            {
                showShimmer ? <ShimmerPage /> :
                    <AfterLoginLayoutWrapper>
                        <ScenarioBasedModal
                            id="bd-modal"
                            isOpen={udyamSkipModal}
                            showCloseButton={false}
                            secondButton={true}
                            onClose={() => { }}
                            modalIcon="!"
                            modalMessage="If you skip Udyam verification then your application will have to go through a manual review."
                            modalSubmitMessage="Cancel"
                            modalSubmitMessagebutton2="Skip anyway"
                            onModalSubmit={() => setUdyamSkipModal(false)}
                            onModalSubmitbutton2={() => udyamSendOtp(true)}  // Pass true to mark as skipped
                        />
                        <ScenarioBasedModal
                            id="bd-modal"
                            isOpen={udyamVerifyError}
                            showCloseButton={false}
                            modalMessageHeading="Attention !"
                            modalMessage={udyamVerifyErrorMessage || "OTP is not valid Please Retry !"}
                            modalSubmitMessage="Ok"
                            onModalSubmit={() => { setUdyamVerifyError(false) }}
                        />
                        <Modal
                            open={showOtpModal}
                            showCloseButton={false}
                            closeonClickOutside={false}
                            onClose={() => {
                                // setShowOtpModal(false);
                            }}
                            id="bd-email-otp-parent"
                        >
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div
                                        className="modal-body"
                                    >
                                        <div className="pupup-inner">
                                            <div className="title text-center">
                                                <h2 className="font-weight-medium text-black mb-2 lh-1" style={{ textAlign: "center" }}>
                                                    Udyam Registration Certificate fetch OTP
                                                </h2>
                                                <p style={{ textAlign: "center" }}>Please provide the OTP to fetch the Udyam registration certificate</p>
                                            </div>
                                            <form>
                                                <div
                                                    style={{
                                                        marginLeft: "10px",
                                                        marginRight: "10px",
                                                        marginTop: "15px",
                                                    }}
                                                >
                                                    <div>
                                                        <OTPInput
                                                            length={6}
                                                            otpDigits={otpDigits}
                                                            setOtpDigits={setOtpDigits}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="mt-5 col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                                                    <div className="col-wrap text-center">
                                                        <Button
                                                            id="VerifyOTP"
                                                            className="Btn VerifyOTP"
                                                            disabled={!isOtpValid}
                                                            mobile={isMobile}
                                                            onClick={async () => {
                                                                await udyamOtpVerify();
                                                            }}
                                                            text={"Verify"}
                                                        />
                                                    </div>
                                                </div>
                                                <p
                                                    style={{
                                                        textAlign: "center",
                                                        paddingTop: "15px",
                                                    }}
                                                >
                                                    6 digit verification code sent will be
                                                    valid for next 5 minutes.
                                                </p>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Title
                            text="Udyam"
                            visible={!showShimmer}
                            clickable={false}
                        />
                        <UdyamWrapper>
                            <FloatingInput
                                visible={!showShimmer}
                                on_change={updateUDYAM}
                                error={UDYAMError}
                                error_message={UDYAMErrorMessage}
                                value={UDYAM}
                                type={"text"}
                                label={"UDYAM"}
                                class_name='mb-4'
                            />
                            <FloatingInput
                                label={"Udyam Registered Mobile Number"}
                                id="MobileNumber"
                                type="Number"
                                value={mobileNumber}
                                error={mobileNumberError}
                                error_message={mobileNumberErrorMessage}
                                on_change={updateMobileNumber}
                            />
                            <div className='d-flex'>
                                <Button
                                    id="ProceedBtn"
                                    className="Btn ProceedBtn"
                                    mobile={isMobile}
                                    onClick={() => setUdyamSkipModal(true)}
                                    text={"Skip"}
                                />
                                <Button
                                    id="ProceedBtn"
                                    className="Btn ProceedBtn"
                                    disabled={!allFieldsValidated()}
                                    mobile={isMobile}
                                    onClick={udyamSendOtp}
                                    text={"Submit"}
                                />
                            </div>
                            <div id="login-privacy-policy-link" style={{ fontSize: "16px" }}>
                                If you have not registered on Udyam, please go to the link below to register on Udyam and provide the number. <br />
                                <a
                                    href="https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm"
                                    style={{ backgroundColor: "none", color: "#0074CC", textDecoration: "underline" }}
                                >
                                    https://udyamregistration.gov.in/Government-India/Ministry-MSME-registration.htm
                                </a>
                            </div>
                        </UdyamWrapper>
                    </AfterLoginLayoutWrapper>
            }
        </>
    )
}

export default Udyam